import {AfterViewInit, ChangeDetectionStrategy, Component, input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";
import {QRCodeComponent} from "angularx-qrcode";
import {TranslatePipe} from "@ngx-translate/core";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";

@Component({
  selector: 'app-home-application',
  imports: [
    NgOptimizedImage,
    QRCodeComponent,
    TranslatePipe,
    SafeHtmlPipe
  ],
  templateUrl: './home-application.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeApplicationComponent implements AfterViewInit {
  qrData = input.required<string>()

  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({
      start: 'top 80%'
    })
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.home-app-section',
      }
    });

    tl.addLabel('start')
      .from('#app-section-title', {
        opacity: 0,
        y: 70,
        duration: 0.3,
      })
      .from('.app-desc', {
        opacity: 0,
        y: 50,
        duration: 0.3,
      })
      .from('.app-scanner', {
        opacity: 0,
        duration: 0.3,
      })
      .from('.app-right__back', {
        opacity: 0,
        duration: 0.3,
      }, '-=0.3')
      .from('.app-right__img', {
        opacity: 0,
        scale: 0,
        duration: 0.3,
      })
  }
}
